import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { EcommerceGuard } from "./guards/ecommerce.guard";
import { IntroGuard } from "./guards/intro.guard";
import { LoginGuard } from "./guards/login.guard";
import { NivelaccesoGuard } from "./guards/nivelacceso.guard";
import { environment } from "../environments/environment";

//**
// routes se ha modificado con una condicion para diferenciar entre
// una aplicacion para Cemlight (software que no permite que los vendedores entren si no estan logueados)
//y Otra para Ilferret que funciona como un ecomerce.

let routes: Routes;
if (environment.ecommerce) {
  routes = [
    {
      path: "",
      redirectTo: "articulos",
      pathMatch: "full",
    },
    // {
    //   path: "intro",
    //   loadChildren: () => import("./intro/intro.module").then((m) => m.IntroPageModule),
    // },
    {
      path: "login",
      loadChildren: () => import("./login/login.module").then((m) => m.LoginPageModule),
      // canActivate: [IntroGuard],
    },
    {
      path: "register",
      loadChildren: () => import("./register/register.module").then((m) => m.RegisterPageModule),
    },
    {
      path: "menu",
      loadChildren: () => import("./menu/menu.module").then((m) => m.MenuPageModule),
      canActivate: [LoginGuard],
      // canActivate: [LoginGuard, IntroGuard],
    },
    {
      path: "home",
      loadChildren: () => import("./home/home.module").then((m) => m.HomePageModule),
      canActivate: [LoginGuard],
      // canActivate: [LoginGuard, IntroGuard],
    },
    {
      path: "articulos",
      loadChildren: () => import("./articulos/articulos.module").then((m) => m.ArticulosPageModule),
    },
    {
      path: "carrito",
      loadChildren: () => import("./carrito/carrito.module").then((m) => m.CarritoPageModule),
    },
    {
      path: "cliente",
      loadChildren: () => import("./cliente/cliente.module").then((m) => m.ClientePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "fb-data-load",
      loadChildren: () => import("./fb-data-load/fb-data-load.module").then((m) => m.FbDataLoadPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "misventas",
      loadChildren: () => import("./misventas/misventas.module").then((m) => m.MisventasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "despachos",
      loadChildren: () => import("./despachos/despachos.module").then((m) => m.DespachosPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "despacho", "despachoEntrega"] },
    },
    {
      path: "despacho",
      loadChildren: () => import("./despacho/despacho.module").then((m) => m.DespachoPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "despacho", "despachoEntrega"] },
    },
    {
      path: "entrega",
      loadChildren: () => import("./entrega/entrega.module").then((m) => m.EntregaPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "entrega", "despachoEntrega"] },
    },
    {
      path: "dinero",
      loadChildren: () => import("./dinero/dinero.module").then((m) => m.DineroPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "venta-detalle",
      loadChildren: () => import("./venta-detalle/venta-detalle.module").then((m) => m.VentaDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "materiales",
      loadChildren: () => import("./materiales/materiales.module").then((m) => m.MaterialesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "todas-las-ventas",
      loadChildren: () => import("./todas-las-ventas/todas-las-ventas.module").then((m) => m.TodasLasVentasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "recupera-datos-clientes",
      loadChildren: () => import("./recupera-datos-clientes/recupera-datos-clientes.module").then((m) => m.RecuperaDatosClientesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "edit-articulo",
      loadChildren: () => import("./edit-articulo/edit-articulo.module").then((m) => m.EditArticuloPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "menu-categorias",
      loadChildren: () => import("./menu-categorias/menu-categorias.module").then((m) => m.MenuCategoriasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "clientdata",
      loadChildren: () => import("./clientdata/clientdata.module").then((m) => m.ClientdataPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "clientev",
      loadChildren: () => import("./clientev/clientev.module").then((m) => m.ClientevPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "pruebacard",
      loadChildren: () => import("./pruebacard/pruebacard.module").then((m) => m.PruebacardPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "misventastabla",
      loadChildren: () => import("./misventastabla/misventastabla.module").then((m) => m.MisventastablaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "todaslasventas-tabla",
      loadChildren: () => import("./todaslasventas-tabla/todaslasventas-tabla.module").then((m) => m.TodaslasventasTablaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "facturas",
      loadChildren: () => import("./facturas/facturas.module").then((m) => m.FacturasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "edit-venta",
      loadChildren: () => import("./edit-venta/edit-venta.module").then((m) => m.EditVentaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "modal-edit-articulo",
      loadChildren: () => import("./modal-edit-articulo/modal-edit-articulo.module").then((m) => m.ModalEditArticuloPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "edit-usuario",
      loadChildren: () => import("./edit-usuario/edit-usuario.module").then((m) => m.EditUsuarioPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "model-edit-usuario",
      loadChildren: () => import("./model-edit-usuario/model-edit-usuario.module").then((m) => m.ModelEditUsuarioPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "cobranzas",
      loadChildren: () => import("./cobranzas/cobranzas.module").then((m) => m.CobranzasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "cobranzas-detalle",
      loadChildren: () => import("./cobranzas-detalle/cobranzas-detalle.module").then((m) => m.CobranzasDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "comisiones",
      loadChildren: () => import("./comisiones/comisiones.module").then((m) => m.ComisionesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "comisiones-detalle",
      loadChildren: () => import("./comisiones-detalle/comisiones-detalle.module").then((m) => m.ComisionesDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "htmltopdf",
      loadChildren: () => import("./pruebas/htmltopdf/htmltopdf.module").then((m) => m.HtmltopdfPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "prueba-articulo-test",
      loadChildren: () => import("./pruebas/prueba-articulo-test/prueba-articulo-test.module").then((m) => m.PruebaArticuloTestPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "ventas-factibilidad",
      loadChildren: () => import("./ventas-factibilidad/ventas-factibilidad.module").then((m) => m.VentasFactibilidadPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "ventafacti-detalle",
      loadChildren: () => import("./ventafacti-detalle/ventafacti-detalle.module").then((m) => m.VentafactiDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "preciodolar",
      loadChildren: () => import("./preciodolar/preciodolar.module").then((m) => m.PreciodolarPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "entregas",
      loadChildren: () => import("./entregas/entregas.module").then((m) => m.EntregasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "entrega", "despachoEntrega"] },
    },

    {
      path: "backup",
      loadChildren: () => import("./backup/backup.module").then((m) => m.BackupPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "miscomisiones",
      loadChildren: () => import("./miscomisiones/miscomisiones.module").then((m) => m.MiscomisionesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },

    {
      path: "gps",
      loadChildren: () => import("./pruebas/gps/gps.module").then((m) => m.GpsPageModule),
    },

    {
      path: "prueba-audio",
      loadChildren: () => import("./pruebas/prueba-audio/prueba-audio.module").then((m) => m.PruebaAudioPageModule),
    },
    {
      path: "notificaciones",
      loadChildren: () => import("./pruebas/notificaciones/notificaciones.module").then((m) => m.NotificacionesPageModule),
    },

    {
      path: "loadimges",
      loadChildren: () => import("./pruebas/loadimges/loadimges.module").then((m) => m.LoadimgesPageModule),
    },

    {
      path: "aprendizaje",
      loadChildren: () => import("./pruebas/aprendizaje/aprendizaje.module").then((m) => m.AprendizajePageModule),
    },

    {
      path: "showfichatecnica",
      loadChildren: () => import("./showfichatecnica/showfichatecnica.module").then((m) => m.ShowfichatecnicaPageModule),
    },

    {
      path: "articulosnew",
      loadChildren: () => import("./articulosnew/articulosnew.module").then((m) => m.ArticulosnewPageModule),
    },
    {
      path: "fb-data-load-new",
      loadChildren: () => import("./fb-data-load-new/fb-data-load-new.module").then((m) => m.FbDataLoadNewPageModule),
    },

    {
      path: "clientes",
      loadChildren: () => import("./clientes/clientes.module").then((m) => m.ClientesPageModule),
    },
    {
      path: "letrasdecambio",
      loadChildren: () => import("./letrasdecambio/letrasdecambio.module").then((m) => m.LetrasdecambioPageModule),
    },

    {
      path: "registered-list",
      loadChildren: () => import("./registered-list/registered-list.module").then((m) => m.RegisteredListPageModule),
    },
    {
      path: "sunat",
      loadChildren: () => import("./sunat/sunat.module").then((m) => m.SunatPageModule),
    },
    {
      path: "sunatnew",
      loadChildren: () => import("./sunatnew/sunatnew.module").then((m) => m.SunatnewPageModule),
    },
    {
      path: "sunat-registro-empresa",
      loadChildren: () => import("./sunat-registro-empresa/sunat-registro-empresa.module").then((m) => m.SunatRegistroEmpresaPageModule),
    },
    {
      path: "soap",
      loadChildren: () => import("./pruebas/soap/soap.module").then((m) => m.SoapPageModule),
    },
    {
      path: "venta-detalle-factura",
      loadChildren: () => import("./venta-detalle-factura/venta-detalle-factura.module").then((m) => m.VentaDetalleFacturaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },

    {
      path: "loadimages",
      loadChildren: () => import("./loadimages/loadimages.module").then((m) => m.LoadimagesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "excel",
      loadChildren: () => import("./pruebas/excel/excel.module").then((m) => m.ExcelPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "domatransfer",
      loadChildren: () => import("./pruebas/domatransfer/domatransfer.module").then((m) => m.DomatransferPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    { path: "**", redirectTo: "/articulos" },
  ];
} else {
  //para cemlight (aplicativo para vendedores)
  routes = [
    {
      path: "",
      redirectTo: "intro",
      pathMatch: "full",
    },
    {
      path: "intro",
      loadChildren: () => import("./intro/intro.module").then((m) => m.IntroPageModule),
    },
    {
      path: "login",
      loadChildren: () => import("./login/login.module").then((m) => m.LoginPageModule),
      // canActivate: [IntroGuard],
    },
    {
      path: "register",
      loadChildren: () => import("./register/register.module").then((m) => m.RegisterPageModule),
    },
    {
      path: "menu",
      loadChildren: () => import("./menu/menu.module").then((m) => m.MenuPageModule),
      canActivate: [LoginGuard],
      // canActivate: [LoginGuard, IntroGuard],
    },
    {
      path: "home",
      loadChildren: () => import("./home/home.module").then((m) => m.HomePageModule),
      canActivate: [LoginGuard],
      // canActivate: [LoginGuard, IntroGuard],
    },
    {
      path: "articulos",
      loadChildren: () => import("./articulos/articulos.module").then((m) => m.ArticulosPageModule),
      canActivate: [LoginGuard],
    },
    {
      path: "carrito",
      loadChildren: () => import("./carrito/carrito.module").then((m) => m.CarritoPageModule),
      canActivate: [LoginGuard],
    },
    {
      path: "cliente",
      loadChildren: () => import("./cliente/cliente.module").then((m) => m.ClientePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "fb-data-load",
      loadChildren: () => import("./fb-data-load/fb-data-load.module").then((m) => m.FbDataLoadPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "misventas",
      loadChildren: () => import("./misventas/misventas.module").then((m) => m.MisventasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "despachos",
      loadChildren: () => import("./despachos/despachos.module").then((m) => m.DespachosPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "despacho", "despachoEntrega"] },
    },
    {
      path: "despacho",
      loadChildren: () => import("./despacho/despacho.module").then((m) => m.DespachoPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "despacho", "despachoEntrega"] },
    },
    {
      path: "entrega",
      loadChildren: () => import("./entrega/entrega.module").then((m) => m.EntregaPageModule),
      canActivate: [NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "entrega", "despachoEntrega"] },
    },
    {
      path: "dinero",
      loadChildren: () => import("./dinero/dinero.module").then((m) => m.DineroPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "venta-detalle",
      loadChildren: () => import("./venta-detalle/venta-detalle.module").then((m) => m.VentaDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },
    {
      path: "materiales",
      loadChildren: () => import("./materiales/materiales.module").then((m) => m.MaterialesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "todas-las-ventas",
      loadChildren: () => import("./todas-las-ventas/todas-las-ventas.module").then((m) => m.TodasLasVentasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "recupera-datos-clientes",
      loadChildren: () => import("./recupera-datos-clientes/recupera-datos-clientes.module").then((m) => m.RecuperaDatosClientesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "edit-articulo",
      loadChildren: () => import("./edit-articulo/edit-articulo.module").then((m) => m.EditArticuloPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "menu-categorias",
      loadChildren: () => import("./menu-categorias/menu-categorias.module").then((m) => m.MenuCategoriasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "clientdata",
      loadChildren: () => import("./clientdata/clientdata.module").then((m) => m.ClientdataPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "clientev",
      loadChildren: () => import("./clientev/clientev.module").then((m) => m.ClientevPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "pruebacard",
      loadChildren: () => import("./pruebacard/pruebacard.module").then((m) => m.PruebacardPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "misventastabla",
      loadChildren: () => import("./misventastabla/misventastabla.module").then((m) => m.MisventastablaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "todaslasventas-tabla",
      loadChildren: () => import("./todaslasventas-tabla/todaslasventas-tabla.module").then((m) => m.TodaslasventasTablaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "facturas",
      loadChildren: () => import("./facturas/facturas.module").then((m) => m.FacturasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "edit-venta",
      loadChildren: () => import("./edit-venta/edit-venta.module").then((m) => m.EditVentaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "modal-edit-articulo",
      loadChildren: () => import("./modal-edit-articulo/modal-edit-articulo.module").then((m) => m.ModalEditArticuloPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "edit-usuario",
      loadChildren: () => import("./edit-usuario/edit-usuario.module").then((m) => m.EditUsuarioPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "model-edit-usuario",
      loadChildren: () => import("./model-edit-usuario/model-edit-usuario.module").then((m) => m.ModelEditUsuarioPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "cobranzas",
      loadChildren: () => import("./cobranzas/cobranzas.module").then((m) => m.CobranzasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "cobranzas-detalle",
      loadChildren: () => import("./cobranzas-detalle/cobranzas-detalle.module").then((m) => m.CobranzasDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "comisiones",
      loadChildren: () => import("./comisiones/comisiones.module").then((m) => m.ComisionesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "comisiones-detalle",
      loadChildren: () => import("./comisiones-detalle/comisiones-detalle.module").then((m) => m.ComisionesDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "htmltopdf",
      loadChildren: () => import("./pruebas/htmltopdf/htmltopdf.module").then((m) => m.HtmltopdfPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "prueba-articulo-test",
      loadChildren: () => import("./pruebas/prueba-articulo-test/prueba-articulo-test.module").then((m) => m.PruebaArticuloTestPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "ventas-factibilidad",
      loadChildren: () => import("./ventas-factibilidad/ventas-factibilidad.module").then((m) => m.VentasFactibilidadPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "ventafacti-detalle",
      loadChildren: () => import("./ventafacti-detalle/ventafacti-detalle.module").then((m) => m.VentafactiDetallePageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "preciodolar",
      loadChildren: () => import("./preciodolar/preciodolar.module").then((m) => m.PreciodolarPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "entregas",
      loadChildren: () => import("./entregas/entregas.module").then((m) => m.EntregasPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "entrega", "despachoEntrega"] },
    },

    {
      path: "backup",
      loadChildren: () => import("./backup/backup.module").then((m) => m.BackupPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "miscomisiones",
      loadChildren: () => import("./miscomisiones/miscomisiones.module").then((m) => m.MiscomisionesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },

    {
      path: "gps",
      loadChildren: () => import("./pruebas/gps/gps.module").then((m) => m.GpsPageModule),
    },

    {
      path: "prueba-audio",
      loadChildren: () => import("./pruebas/prueba-audio/prueba-audio.module").then((m) => m.PruebaAudioPageModule),
    },
    {
      path: "notificaciones",
      loadChildren: () => import("./pruebas/notificaciones/notificaciones.module").then((m) => m.NotificacionesPageModule),
    },

    {
      path: "loadimges",
      loadChildren: () => import("./pruebas/loadimges/loadimges.module").then((m) => m.LoadimgesPageModule),
    },

    {
      path: "aprendizaje",
      loadChildren: () => import("./pruebas/aprendizaje/aprendizaje.module").then((m) => m.AprendizajePageModule),
    },

    {
      path: "showfichatecnica",
      loadChildren: () => import("./showfichatecnica/showfichatecnica.module").then((m) => m.ShowfichatecnicaPageModule),
    },

    {
      path: "articulosnew",
      loadChildren: () => import("./articulosnew/articulosnew.module").then((m) => m.ArticulosnewPageModule),
    },
    {
      path: "fb-data-load-new",
      loadChildren: () => import("./fb-data-load-new/fb-data-load-new.module").then((m) => m.FbDataLoadNewPageModule),
    },

    {
      path: "clientes",
      loadChildren: () => import("./clientes/clientes.module").then((m) => m.ClientesPageModule),
    },
    {
      path: "letrasdecambio",
      loadChildren: () => import("./letrasdecambio/letrasdecambio.module").then((m) => m.LetrasdecambioPageModule),
    },
    {
      path: "registered-list",
      loadChildren: () => import("./registered-list/registered-list.module").then((m) => m.RegisteredListPageModule),
    },
    {
      path: "soap",
      loadChildren: () => import("./pruebas/soap/soap.module").then((m) => m.SoapPageModule),
    },
    {
      path: "venta-detalle-factura",
      loadChildren: () => import("./venta-detalle-factura/venta-detalle-factura.module").then((m) => m.VentaDetalleFacturaPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin", "venta"] },
    },

    {
      path: "loadimages",
      loadChildren: () => import("./loadimages/loadimages.module").then((m) => m.LoadimagesPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },

    {
      path: "excel",
      loadChildren: () => import("./pruebas/excel/excel.module").then((m) => m.ExcelPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    {
      path: "domatransfer",
      loadChildren: () => import("./pruebas/domatransfer/domatransfer.module").then((m) => m.DomatransferPageModule),
      canActivate: [LoginGuard, NivelaccesoGuard],
      data: { roles: ["admin", "superadmin"] },
    },
    { path: "**", redirectTo: "/intro" },
  ];
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
